// @flow
import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Block, BlockContent, BlockHeading } from '@gandi/ui';

export function NoWarranty(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Block>
      <BlockHeading>{__('Warranty')}</BlockHeading>
      <BlockContent>{__('No warranty')}</BlockContent>
    </Block>
  );
}
